import React, { useMemo } from 'react';
import { Typography, Box } from '@mui/material';
import Chart from 'react-apexcharts';
import Title from './Title';

export default function DailyChart({ todayData, ...props }) {
    const data = todayData;

    const options = { month: 'long' };
    const monthName = new Intl.DateTimeFormat('en-US', options).format(new Date());

    // Transform data for ApexCharts
    const chartData = useMemo(() => {
        if (!data || !Array.isArray(data)) return { series: [] };

        // Transform data to use timestamps for datetime x-axis
        const series = [
            {
                name: 'Daily Tickets',
                data: data.map((item) => ({
                    x: new Date(item.date).getTime(),
                    y: item.DailyTickets ?? 0,
                })),
            },
            {
                name: 'Daily Created Tickets',
                data: data.map((item) => ({
                    x: new Date(item.date).getTime(),
                    y: item.DailyCreatedTickets ?? 0,
                })),
            },
            {
                name: 'Daily Tickets (Last Month)',
                data: data.map((item) => ({
                    x: new Date(item.date).getTime(),
                    y: item.DailyTicketsLastMonth ?? 0,
                })),
            },
            {
                name: 'Daily Created Tickets (Last Month)',
                data: data.map((item) => ({
                    x: new Date(item.date).getTime(),
                    y: item.DailyCreatedTicketsLastMonth ?? 0,
                })),
            },
        ];

        return { series };
    }, [data]);

    const chartOptions = {
        chart: {
            type: 'bar',
            stacked: false,
            toolbar: {
                show: true,
            },
            zoom: {
                enabled: true,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                dataLabels: {
                    position: 'top',
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
        },
        xaxis: {
            type: 'datetime',
            labels: {
                datetimeUTC: false,
                format: 'MMM dd',
            },
        },
        yaxis: {
            title: {
                text: 'Tickets',
            },
        },
        colors: ['#413ea0', '#A52A2A', '#82ca9d', '#FFC0CB'],
        tooltip: {
            shared: true,
            intersect: false,
            x: {
                format: 'dd MMM yyyy',
            },
            y: {
                formatter: (val) => val,
            },
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'right',
        },
        grid: {
            borderColor: '#e7e7e7',
            strokeDashArray: 3,
        },
    };

    return (
        <Box>
            <Title>{monthName} - Daily Tickets</Title>

            {data && data.length > 0 ? (
                <Chart options={chartOptions} series={chartData.series} type="bar" height={300} width="100%" />
            ) : (
                <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 4 }}>
                    No data available
                </Typography>
            )}
        </Box>
    );
}
